import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { getApiUrl } from "../services/api_service";
import {
    Box, Button, Checkbox, CircularProgress, CssBaseline, Dialog, DialogActions, DialogContent, DialogTitle,
    Divider, FormControlLabel, FormGroup, Grid, IconButton, LinearProgress, Radio, RadioGroup, Snackbar, TextField
} from "@mui/material";
import MetaDecorator from "../services/meta_decorator";
import { Alert, Typography } from "@mui/material";
import dayjs from "dayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CloseIcon from '@mui/icons-material/Close';
import { Navigate } from "react-router-dom";
import NDReferralHeader from "../components/shared/ndreferralheader";
import { bodyBg, fullHeight, headerText, mainGrid, orangecolor, pcolor, rcolor, whitecolor } from "../style2";
import BackToTop from "../components/shared/scrollTop";
import { DownloadFormButton } from "../components/shared/downloadformbutton";


export default function ProcessForm(props) {
    const { orgCode, id } = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [form, setForm] = useState(null);
    const [referral, setReferral] = useState(null);
    const [patient, setPatient] = useState(null);
    const [sectionIndex, setSectionIndex] = useState(0);
    const [validateQuestion, setValidateQuestions] = useState(false);
    const [dummy, setDummy] = useState(Date.UTC());
    const [redirect, setRedirect] = useState('');
    const [showSubmitConfirmModal, setShowSubmitConfirmModal] = useState(false);
    const [readOnly, setReadOnly] = useState(false);
    const [autoSaved, setAutoSaved] = useState(false);
    const autoSaveTimerRef = useRef(null);
    const autoSaveHideTimerRef = useRef(null);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            localStorage.clear();
            setRedirect(`/login/${orgCode}`);
            return;
        }
        fetch(getApiUrl() + "/ReferrerAccount/istokenvalid", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                localStorage.clear();
                setRedirect(`/login/${orgCode}`);
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        });
    }, [])

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/login/${orgCode}`);
            return;
        }
        setLoading(true);
        fetch(`${getApiUrl()}/patientform/${id}`, { method: 'GET', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        //console.log(data);
                        setForm(data.form);
                        setPatient(data.patient);
                        setReferral(data.referral);
                        setReadOnly(data.readOnly)
                    });
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }, [id]);

    const prepareAnswerList = () => {
        let answers = []
        form.sections.map(section => {
            section.questions.map(question => {
                if (question.answerType === 1 || question.answerType === 2 || question.answerType === 3) {
                    answers.push({ questionId: question.id, answer: question.answerText, selectedOptions: [] });
                } else if (question.answerType === 4 || question.answerType === 6 || question.answerType === 7) {
                    let selectedOptionIds = [];
                    question.options.filter(t => t.selected).map(item => { selectedOptionIds.push(item.id); });

                    answers.push({ questionId: question.id, answer: null, selectedOptions: selectedOptionIds });
                } else if (question.answerType === 5 && question.questions != null) {
                    question.questions.map(subQuestion => {
                        if (subQuestion.answerType === 1 || subQuestion.answerType === 2 || subQuestion.answerType === 3) {
                            answers.push({ questionId: subQuestion.id, answer: subQuestion.answerText, selectedOptions: [] });
                        } else if (subQuestion.answerType === 4 || subQuestion.answerType === 6 || subQuestion.answerType === 7) {
                            let selectedOptionIds = [];
                            subQuestion.options.filter(t => t.selected).map(item => { selectedOptionIds.push(item.id); });
                            answers.push({ questionId: subQuestion.id, answer: null, selectedOptions: selectedOptionIds });
                        } else if (subQuestion.answerType === 8) {
                            const gridRows = (subQuestion.gridRows || []).map(row => ({
                                rowId: row.id,
                                supportAnswerText: row.supportAnswerText || '',
                                cells: (row.cells || []).map(cell => ({
                                    columnId: cell.columnId,
                                    isSelected: cell.isSelected || false,
                                    answerText: cell.answerText || ''
                                }))
                            }));
                            answers.push({ questionId: subQuestion.id, answer: null, selectedOptions: [], gridRows });
                        }
                    })
                } else if (question.answerType === 8) {
                    const gridRows = (question.gridRows || []).map(row => ({
                        rowId: row.id,
                        supportAnswerText: row.supportAnswerText || '',
                        cells: (row.cells || []).map(cell => ({
                            columnId: cell.columnId,
                            isSelected: cell.isSelected || false,
                            answerText: cell.answerText || ''
                        }))
                    }));
                    answers.push({ questionId: question.id, answer: null, selectedOptions: [], gridRows });
                }
            })
        });
        return answers;
    }

    const saveAnswers = () => {
        if (form.status === 3 || form.status === 4) {
            setError("Submitted / Complete forms cannot be edited.");
            return;
        }
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        setLoading(true);
        fetch(`${getApiUrl()}/patientform/setanswers/${id}`, {
            method: 'POST',
            body: JSON.stringify(prepareAnswerList()),
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } 
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        setForm(data);
                        setSuccess('Answers saved in draft.');
                    });
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }

    const autoSaveAnswersQuiet = () => {
        if (readOnly || !form || form.status === 3 || form.status === 4) return;
        const authTokens = localStorage.getItem("authTokens");
        let token;
        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) return;
        fetch(`${getApiUrl()}/patientform/setanswers/${id}`, {
            method: 'POST',
            body: JSON.stringify(prepareAnswerList()),
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
        }).then(response => {
            if (response.status === 200) {
                response.json().then(data => {
                    // Merge only computed server-side fields to avoid clobbering in-flight typed answers
                    setForm(prev => ({
                        ...prev,
                        progressPercentage: data.progressPercentage,
                        status: data.status
                    }));
                });
                setAutoSaved(true);
                clearTimeout(autoSaveHideTimerRef.current);
                autoSaveHideTimerRef.current = setTimeout(() => setAutoSaved(false), 2500);
            }
        }).catch(err => {
            console.log(err);
        });
    };

    const scheduleAutoSave = (delay = 1000) => {
        if (readOnly || !form || form.status === 3 || form.status === 4) return;
        clearTimeout(autoSaveTimerRef.current);
        autoSaveTimerRef.current = setTimeout(() => {
            autoSaveAnswersQuiet();
        }, delay);
    };

    const setSubmitted = () => {
        if (form.status === 3 || form.status === 4) {
            setError("Completed/Submitted forms cannot be completed again.");
            return;
        }
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }

        setLoading(true);
        setShowSubmitConfirmModal(false);
        fetch(`${getApiUrl()}/patientform/setsubmitted/${id}`, {
            method: 'POST',
            body: JSON.stringify(prepareAnswerList()),
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } 
        })
            .then(response => {
                if (response.status === 200) {

                    response.json().then(data => {
                        setForm(data);
                        setSuccess("Form is completed.");
                    })
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }

    const autoFillFunc = () => {
        if (referral === null)
            return;

        if (form.sections !== null) {
            form.sections.map((section, index) => {
                if (index !== sectionIndex)
                    return null;
                if (section.questions !== null) {
                    section.questions.map((question, qIndex) => {
                        let qt = question.questionText.toLowerCase();
                        //console.log(`QT: ${qt}, AnswerType: ${question.answerType}`);
                        if (question.answerType === 1 || question.answerType === 2 || question.answerType === 3) {
                            if ((question.answerText === null || question.answerText === "")) {

                                if (qt === "dob" || qt == "date of birth") {
                                    question.answerText = dayjs(referral.dob).format("YYYY-MM-DD");
                                } else if (qt === "forename" || qt === "firstname" || qt === "first name" || qt == "name of child") {
                                    question.answerText = referral.firstName;
                                }
                                else if (qt === "surname" || qt === "lastname" || qt === "last name") {
                                    question.answerText = referral.surName;
                                } else if (qt === "nhsnumber" || qt === "nhs number") {
                                    question.answerText = referral.nhsNumber;
                                }
                                else if (qt === "postcode" || qt === "post code") {
                                    question.answerText = referral.postCode;
                                }
                            }
                        } else if (question.answerType === 5) {
                            if (question.questions !== null) {

                                {
                                    question.questions.map((subQuestion) => {
                                        let sqt = subQuestion.questionText.toLowerCase();
                                        //console.log(`QT: ${sqt}, AnswerType: ${subQuestion.answerType}`);
                                        if (subQuestion.answerType === 1 || subQuestion.answerType === 2 || subQuestion.answerType === 3) {
                                            if ((subQuestion.answerText === null || subQuestion.answerText === "")) {
                                                if (sqt == "dob" || sqt == "date of birth") {
                                                    subQuestion.answerText = dayjs(referral.dob).format("YYYY-MM-DD");
                                                } else if (sqt === "forename" || sqt === "firstname" || sqt === "first name" || sqt == "name of child") {
                                                    subQuestion.answerText = referral.firstName;
                                                }
                                                else if (sqt === "surname" || sqt === "lastname" || sqt === "last name") {
                                                    subQuestion.answerText = referral.surName;
                                                } else if (sqt === "nhsnumber" || sqt === "nhs number") {
                                                    subQuestion.answerText = referral.nhsNumber;
                                                } else if (sqt === "postcode" || sqt === "post code") {
                                                    subQuestion.answerText = referral.postCode;
                                                }
                                            }
                                        }
                                    })
                                }

                            }
                        }
                    })
                }
            })
        }
        setForm(form);
        setDummy(new Date());

    }

    const sectionAnsweredComplete = () => {
        if (form != null && form.sections !== null) {
            let section = form.sections[sectionIndex];
            for (let k in section.questions) {
                let question = section.questions[k];
                if ((question.answerType === 1 || question.answerType === 2 || question.answerType === 3) && question.isRequired) {
                    if (question.answerText === null || question.answerText === "")
                        return false;
                }
                if ((question.answerType === 4 || question.answerType === 6 || question.answerType === 7) && question.isRequired) {
                    if (question.options.filter(t => t.selected).length === 0)
                        return false;
                } else if (question.answerType === 5 && question.isRequired) {
                    if (question.questions !== null) {
                        for (let l in question.questions) {
                            let subQuestion = question.questions[l];

                            if (subQuestion.answerType === 1 || subQuestion.answerType === 2 || subQuestion.answerType === 3) {
                                if (subQuestion.answerText === null || subQuestion.answerText === "")
                                    return false;
                            }
                            if (subQuestion.answerType === 4 || subQuestion.answerType === 6 || subQuestion.answerType === 7) {
                                if (subQuestion.options.filter(t => t.selected).length === 0)
                                    return false;
                            }
                            if (subQuestion.answerType === 8) {
                                if (!subQuestion.gridRows || subQuestion.gridRows.length === 0) return false;
                                const hasGridAnswer = subQuestion.gridRows.some(row =>
                                    row.cells && row.cells.some(cell => cell.isSelected || (cell.answerText && cell.answerText !== ''))
                                );
                                if (!hasGridAnswer) return false;
                            }
                        }

                    }
                } else if (question.answerType === 8 && question.isRequired) {
                    if (!question.gridRows || question.gridRows.length === 0) return false;
                    const hasGridAnswer = question.gridRows.some(row =>
                        row.cells && row.cells.some(cell => cell.isSelected || (cell.answerText && cell.answerText !== ''))
                    );
                    if (!hasGridAnswer) return false;
                }
            }
        }
        return true;
    }

    const isFormReadOnly = () => {
        return readOnly;
    }

    if (redirect !== "")
        return <Navigate to={redirect} />

    return <Box sx={{ ...bodyBg, ...fullHeight }}>
        <CssBaseline />
        <MetaDecorator title={"EnrichMyCare - Answer Form"} description={"Answer Form"} />
        <NDReferralHeader date={Date.UTC()} orgCode={orgCode} logo="../../../logo.jpg" />
        {form !== null ? <>
            <Snackbar open={error !== ""} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={60000}
                onClose={() => { setError('') }} message={error}
                action={<>
                    <IconButton size="small" aria-label="close" color="inherit" onClick={() => { setError('') }}> <CloseIcon fontSize="small" /> </IconButton>
                </>}
            />
            <Snackbar open={success !== ""} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={60000} onClose={() => { setSuccess('') }}
                message={success} action={<> <IconButton size="small" aria-label="close" color="inherit" onClick={() => { setSuccess('') }}> <CloseIcon fontSize="small" /> </IconButton> </>}
            />
            <Box pt={1} sx={{ ...bodyBg, marginTop: "5px" }} p={5}>
                <Grid container sx={{ flexGrow: 1, my:3 }} spacing={0}>
                    <Grid item size={{ sm: 12, md: 6 }}>
                        {referral !== null ? <Box pt={1} pb={1}>
                            <Button sx={{ background: pcolor, borderRadius: "20px", height: "40px", color: whitecolor, paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                setRedirect(`/details/${orgCode}/${referral.id}`);
                            }}>Back to Forms</Button>
                        </Box> : null}
                        <Typography variant="body1" mt={2} mb={3} style={{ fontSize: "1.4rem" }}>
                            {patient !== null ? <span style={{ textTransform: "capitalize", fontWeight:"bold" }}>{`${patient.firstName} ${patient.surname}`}</span> : null}
                            {patient !== null ? <span style={{display:"block", marginTop: 7}}>DOB: {dayjs(patient.dob).format('DD-MM-YYYY')}, <span style={{marginLeft:5}}>NHS Number: {patient.nhsNumber}</span></span> : null}
                        </Typography>
                    </Grid>
                    <Grid item size={{ sm: 12, md: 6 }} sx={{ textAlign: "right" }}>
                        
                    </Grid>
                </Grid>
                <Grid container sx={{ flexGrow: 1 }} spacing={0}>
                    <Grid item size={6}>
                        <Typography variant="h5" sx={{ ...headerText, fontWeight: "bold" }} mb={2}>
                            {form.title} {isFormReadOnly() ? "(Read Only)" : null}
                        </Typography>
                    </Grid>
                    <Grid item size={6} style={{ textAlign: "right" }}>

                        {isFormReadOnly() ? <DownloadFormButton color="error" form={form} /> : <>
                            <span style={{ marginRight: "20px" }}><span style={{ color: rcolor }}>*</span> Mandatory</span>
                            {/* <Button type="button" variant="contained" disabled={loading} onClick={() => { autoFillFunc(); }}
                                style={{ background: orangecolor, borderRadius: 15, width: "150px", color: whitecolor, textTransform: "capitalize", marginLeft: "15px", marginRight: "15px" }}>Auto Fill</Button> */}
                                </>}

                                {/* {(form.status === 1 || form.status === 2) && !isFormReadOnly() ? <Button variant="contained" disabled={loading}
                            style={{ background: orangecolor, borderRadius: 15, width: "150px", color: whitecolor, textTransform: "capitalize" }}
                            onClick={() => {
                                saveAnswers();
                            }}>{loading ? <CircularProgress color="inherit" size="20px" marginRight={1} /> : null} Save</Button> : null} */}
                    </Grid>
                </Grid>
                <Box pt={2} pb={2}>
                    <LinearProgress variant="determinate" sx={{ height: "15px", borderRadius: "20px" }} value={form.progressPercentage} />
                </Box>
                <Box pb={2} sx={{ marginBottom: "30px" }}>
                    {form.sections !== null && form.sections.map((section, index) => {
                        if (index !== sectionIndex)
                            return null;
                        return <Box sx={mainGrid} key={index} >
                            <Typography variant="h6" sx={{ ...headerText, fontWeight: "bold" }} mb={2}>{section.title}</Typography>

                            {section.questions !== null && section.questions.map((question, qIndex) => {
                                if (question.answerType === 1) {
                                    return <Box style={{ marginBottom: "50px" }}>
                                        {/* Pass readOnly so the field is locked when the form is in read-only mode */}
                                        <DateQuestionDisplay validate={validateQuestion} dummy={dummy} question={question} readOnly={isFormReadOnly()} onChange={(value) => {
                                            question.answerText = value;
                                            setForm(form);
                                            scheduleAutoSave();
                                        }} />

                                        <Divider />
                                    </Box>;
                                } else if (question.answerType === 2) {
                                    return <Box style={{ marginBottom: "50px" }}>
                                        {/* Pass readOnly so the field is locked when the form is in read-only mode */}
                                        <TextQuestionDisplay validate={validateQuestion} dummy={dummy} question={question} readOnly={isFormReadOnly()} onChange={(value) => {
                                            question.answerText = value;
                                            setForm(form);
                                            scheduleAutoSave(1500);
                                        }} />

                                        <Divider />
                                    </Box>;
                                } else if (question.answerType === 3) {
                                    return <Box style={{ marginBottom: "50px" }}>
                                        {/* Pass readOnly so the field is locked when the form is in read-only mode */}
                                        <NumberQuestionDisplay validate={validateQuestion} question={question} readOnly={isFormReadOnly()} onChange={(value) => {
                                            question.answerText = value;
                                            setForm(form);
                                            scheduleAutoSave();
                                        }} />
                                        <Divider />
                                    </Box>;
                                } else if (question.answerType === 4 || question.answerType === 6 || question.answerType === 7) {
                                    return <Box style={{ marginBottom: "50px" }}>
                                        {/* Pass readOnly so the field is locked when the form is in read-only mode */}
                                        <MultipleChoiceQuestionDisplay validate={validateQuestion} question={question} readOnly={isFormReadOnly()} onChange={(selectedIds) => {
                                            question.options.map(item => {
                                                if (selectedIds.filter(t => t === item.id).length === 0) {
                                                    item.selected = false;
                                                } else {
                                                    item.selected = true;
                                                }
                                            });
                                            setForm(form);
                                            scheduleAutoSave();
                                        }} />

                                        <Divider />
                                    </Box>;
                                } else if (question.answerType === 5) {
                                    if (question.questions !== null) {
                                        return <Box pb={2} pt={2} style={{ marginBottom: "50px" }}>
                                            <Typography pb={1} style={{ whiteSpace: 'pre-line' }}>{question.sequence}. {question.questionText} {question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
                                            <Box pl={2} pr={2}>
                                                <Grid container sx={{ flexGrow: 1 }} spacing={0}>
                                                    {question.questions.map((subQuestion) => {
                                                        subQuestion.isRequired = question.isRequired;
                                                        if (subQuestion.answerType === 1) {
                                                            return <Grid item size={6} >
                                                                <Box pl={1}>
                                                                    {/* Pass readOnly so sub-question field is locked when the form is in read-only mode */}
                                                    <DateQuestionDisplay dummy={dummy} sequencePrefix={`${question.sequence}.`} validate={validateQuestion} question={subQuestion} readOnly={isFormReadOnly()} onChange={(value) => {
                                                                        subQuestion.answerText = value;
                                                                        setForm(form);
                                                                        scheduleAutoSave();
                                                                    }} />

                                                                </Box>
                                                            </Grid>;
                                                        } else if (subQuestion.answerType === 2) {
                                                            return <Grid item size={6} >
                                                                <Box pl={1}>
                                                                    {/* Pass readOnly so sub-question field is locked when the form is in read-only mode */}
                                                    <TextQuestionDisplay dummy={dummy} sequencePrefix={`${question.sequence}.`} validate={validateQuestion} question={subQuestion} readOnly={isFormReadOnly()} onChange={(value) => {
                                                                        subQuestion.answerText = value;
                                                                        setForm(form);
                                                                        scheduleAutoSave(1500);
                                                                    }} />
                                                                </Box>
                                                            </Grid>;
                                                        } else if (subQuestion.answerType === 3) {
                                                            return <Grid item size={6} >
                                                                <Box pl={1}>
                                                                    {/* Pass readOnly so sub-question field is locked when the form is in read-only mode */}
                                                    <NumberQuestionDisplay sequencePrefix={`${question.sequence}.`} validate={validateQuestion} question={subQuestion} readOnly={isFormReadOnly()} onChange={(value) => {
                                                                        subQuestion.answerText = value;
                                                                        setForm(form);
                                                                        scheduleAutoSave();
                                                                    }} />
                                                                </Box>
                                                            </Grid>;
                                                        } else if (subQuestion.answerType === 4 || subQuestion.answerType === 6 || subQuestion.answerType === 7) {
                                                            return <Grid item size={6} >
                                                                <Box pl={1}>
                                                                    {/* Pass readOnly so sub-question field is locked when the form is in read-only mode */}
                                                    <MultipleChoiceQuestionDisplay sequencePrefix={`${question.sequence}.`} validate={validateQuestion} question={subQuestion} readOnly={isFormReadOnly()} onChange={(selectedIds) => {
                                                                        subQuestion.options.map(item => {
                                                                            if (selectedIds.filter(t => t === item.id).length === 0) {
                                                                                item.selected = false;
                                                                            } else {
                                                                                item.selected = true;
                                                                            }
                                                                        });
                                                                        setForm(form);
                                                                        setValidateQuestions(false);
                                                                        scheduleAutoSave();
                                                                    }} />
                                                                </Box>
                                                            </Grid>;
                                                        } else if (subQuestion.answerType === 8) {
                                                            return <Grid item size={12} >
                                                                <Box pl={1}>
                                                                    <GridQuestionDisplay
                                                                        sequencePrefix={`${question.sequence}.`}
                                                                        validate={validateQuestion}
                                                                        question={subQuestion}
                                                                        readOnly={isFormReadOnly()}
                                                                        onChange={(gridRows) => {
                                                                            subQuestion.gridRows = gridRows;
                                                                            setForm(form);
                                                                            scheduleAutoSave();
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Grid>;
                                                        } else
                                                            return null;
                                                    })}
                                                </Grid>
                                            </Box>
                                        </Box>;
                                    } else
                                        return null;
                                } else if (question.answerType === 8) {
                                    return <Box style={{ marginBottom: "50px" }}>
                                        <GridQuestionDisplay
                                            validate={validateQuestion}
                                            question={question}
                                            readOnly={isFormReadOnly()}
                                            onChange={(gridRows) => {
                                                question.gridRows = gridRows;
                                                setForm(form);
                                                scheduleAutoSave();
                                            }}
                                        />
                                        <Divider />
                                    </Box>;
                                } else
                                    return null;
                            })}
                        </Box>;
                    })}
                </Box>
            </Box>
            {autoSaved && (
                <Box sx={{ position: "fixed", bottom: "80px", right: "20px", background: "#4caf50", color: "#fff", padding: "6px 20px", borderRadius: "20px", zIndex: 9999, fontSize: "0.9rem", boxShadow: "0 2px 8px rgba(0,0,0,0.2)" }}>
                    Saved
                </Box>
            )}
            <Box sx={{ width: "100%", background: "#F1EFDF", position: "fixed", bottom: 0, textAlign: "center" }}>
                <Box mt={2} mb={2}>
                    <Grid container sx={{ flexGrow: 1 }} spacing={0}>
                        <Grid item size={6}>
                            <Box sx={{ paddingRight: 1, textAlign: "right" }}>
                                {sectionIndex > 0 ? <Button disabled={sectionIndex === 0 || loading} style={{ borderRadius: 15, background: "#fff", width: "100px", border: `2px solid ${orangecolor}`, textTransform: "capitalize" }} onClick={() => {
                                    if (sectionIndex > 0)
                                        setSectionIndex(sectionIndex - 1);
                                }}>Previous</Button> : null}
                                {/* {(form.status === 1 || form.status === 2) && !isFormReadOnly() ? <>
                                    <Button variant="contained" disabled={loading}
                            style={{ background: orangecolor, borderRadius: 15, minWidth: "100px", color: whitecolor, textTransform: "capitalize", marginLeft:"20px" }}
                            onClick={() => {
                                saveAnswers();
                            }}>{loading ? <CircularProgress color="inherit" size="20px" marginRight={1} /> : null} Save</Button></> : null} */}
                            </Box>
                        </Grid>
                        <Grid item size={6} sx={{ paddingLeft: 1 }}>
                            <Box sx={{ paddingLeft: 1, textAlign: "left" }}>
                                {sectionIndex + 1 < form.sections.length ? <Button disabled={loading} style={{ background: orangecolor, borderRadius: 15, width: "100px", color: "#fff", textTransform: "capitalize" }} onClick={() => {
                                    setValidateQuestions(true);
                                    setDummy(new Date());
                                    if (form.sections.length > sectionIndex + 1 && sectionAnsweredComplete()) {
                                        setSectionIndex(sectionIndex + 1);
                                        setValidateQuestions(false);
                                    }
                                }}>Next</Button> :
                                    (form.status === 1 || form.status === 2) && !isFormReadOnly() ? <>
                                        <Button disabled={loading} style={{ background: orangecolor, width: "100px", borderRadius: 15, color: "#fff", textTransform: "capitalize" }}
                                            onClick={() => {
                                                setValidateQuestions(true);
                                                setDummy(new Date());
                                                if (sectionAnsweredComplete()) {
                                                    setShowSubmitConfirmModal(true);
                                                }
                                            }}>
                                            {loading ? <CircularProgress color="inherit" size="20px" marginRight={1} /> : null} Complete
                                        </Button>
                                        <Dialog
                                            open={showSubmitConfirmModal}
                                            onClose={() => { setShowSubmitConfirmModal(false); }}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title">
                                                <Typography style={{ fontSize: "1.3rem", fontWeight: "bold" }}>Please Confirm!</Typography>
                                            </DialogTitle>
                                            <DialogContent>
                                                <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>
                                                    You will not be able to edit the answer once the form is completed.</Box>
                                                <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>
                                                    Are you sure you wish to complete?</Box>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button style={{ marginRight: "30px" }} onClick={() => { setShowSubmitConfirmModal(false); }}>Cancel</Button>
                                                <Button type="button" onClick={() => { setSubmitted(); }} style={{ background: orangecolor, width: "100px", borderRadius: 15, color: "#fff", textTransform: "capitalize" }}>Complete</Button>
                                            </DialogActions>
                                        </Dialog>
                                    </> : null}
                                    
                                <BackToTop />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

        </> : <>
            {loading ? <Box sx={{ textAlign: "center", py: 5 }}>
                <CircularProgress color="inherit" size={30} />
                <Typography sx={{ mt: 1, color: pcolor }}>Loading form...</Typography>
            </Box> : null}
            {!loading && error ? <Alert severity="error">{error}</Alert> : null}
        </>}


    </Box>;
}

/**
 * Renders a date input field for a form question.
 * @param {Object}   props.question        - Question data (answerText, questionText, sequence, isRequired)
 * @param {boolean}  props.readOnly        - When true, the date field is read-only and cannot be edited
 * @param {boolean}  props.validate        - When true, shows a validation error for unanswered required fields
 * @param {string}   props.sequencePrefix  - Optional prefix string prepended to the question sequence number
 * @param {Function} props.onChange        - Callback invoked with the new date string value on change
 * @param {*}        props.dummy           - Dummy value used to force a re-render when answers are auto-filled
 */
export function DateQuestionDisplay(props) {
    const [answer, setAnswer] = useState('');
    const inputRef = useRef(null);
    useEffect(() => {
        setAnswer(props.question.answerText !== null && props.question.answerText !== "" ? props.question.answerText : "");

        if (inputRef.current != null && props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "")) {
            inputRef.current.focus();
            //inputRef.current.scrollIntoView();
        }
    }, [JSON.stringify(props.question)]);

    return <Box pb={2} pt={2}>
        <Typography pb={1} style={{ whiteSpace: 'pre-line' }}>{props.sequencePrefix}{props.question.sequence}. {props.question.questionText} {props.question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
        <Box pl={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    format="DD/MM/YYYY"
                    value={answer && dayjs(answer).isValid() ? dayjs(answer) : null}
                    readOnly={props.readOnly}
                    inputRef={inputRef}
                    onChange={(newValue) => {
                        if (props.readOnly) return;
                        const formatted = newValue && newValue.isValid() ? newValue.format('YYYY-MM-DD') : '';
                        setAnswer(formatted);
                        props.onChange(formatted);
                    }}
                    slotProps={{
                        textField: {
                            required: props.question.isRequired,
                            variant: 'outlined',
                            style: { border: '1px solid #115C71', borderRadius: 5, width: '80%' }
                        }
                    }}
                />
            </LocalizationProvider>
            {props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "") ? <Alert severity="error" style={{ background: "transparent" }}>Required</Alert> : null}
        </Box>
    </Box>;
}

/**
 * Renders a single-line or multi-line text input field for a form question.
 * @param {Object}   props.question        - Question data (answerText, questionText, sequence, isRequired, acceptMultiline)
 * @param {boolean}  props.readOnly        - When true, the text field is read-only and cannot be edited
 * @param {boolean}  props.validate        - When true, shows a validation error for unanswered required fields
 * @param {string}   props.sequencePrefix  - Optional prefix string prepended to the question sequence number
 * @param {Function} props.onChange        - Callback invoked with the new text value on change
 * @param {*}        props.dummy           - Dummy value used to force a re-render when answers are auto-filled
 */
function TextQuestionDisplay(props) {
    const [answer, setAnswer] = useState('');
    const inputRef = useRef(null);
    useEffect(() => {
        setAnswer(props.question.answerText);
        if (inputRef.current != null && props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "")) {
            inputRef.current.focus();
            //inputRef.current.scrollIntoView();
        }
    }, [JSON.stringify(props.question)]);

    return <Box pb={2} pt={2} >
        <Typography pb={1} style={{ whiteSpace: 'pre-line' }}>{props.sequencePrefix}{props.question.sequence}. {props.question.questionText} {props.question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
        <Box pl={2}>
            {/* readOnly is passed into native inputProps to prevent editing when the form is read-only */}
            <TextField inputRef={inputRef} multiline={props.question.acceptMultiline} style={{ border: "1px solid #115C71", borderRadius: 5, width: "80%" }} isRequired={props.question.isRequired} variant="outlined" value={answer} inputProps={{ readOnly: props.readOnly, maxLength: props.question.acceptMultiline ? 3000 : 300 }} onChange={(event) => {
                // Do not update state when the field is in read-only mode
                if (props.readOnly) return;
                setAnswer(event.target.value);
                props.onChange(event.target.value);
            }} />
            <Typography variant="caption" style={{ display: "block", textAlign: "right", width: "80%", color: (answer?.length ?? 0) >= (props.question.acceptMultiline ? 3000 : 300) ? "#e57373" : "#888" }}>
                {answer?.length ?? 0} / {props.question.acceptMultiline ? 3000 : 300}
            </Typography>
            {props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "") ? <Alert severity="error" style={{ background: "transparent" }}>Required</Alert> : null}
        </Box>

    </Box>
}

/**
 * Renders a numeric input field for a form question. Only accepts digits (0-9).
 * @param {Object}   props.question        - Question data (answerText, questionText, sequence, isRequired)
 * @param {boolean}  props.readOnly        - When true, the number field is read-only and cannot be edited
 * @param {boolean}  props.validate        - When true, shows a validation error for unanswered required fields
 * @param {string}   props.sequencePrefix  - Optional prefix string prepended to the question sequence number
 * @param {Function} props.onChange        - Callback invoked with the new numeric string value on change
 */
function NumberQuestionDisplay(props) {
    const [answer, setAnswer] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        setAnswer(props.question.answerText === null ? "" : props.question.answerText);
        if (inputRef.current != null && props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "")) {
            inputRef.current.focus();
            //inputRef.current.scrollIntoView();
        }
    }, [JSON.stringify(props.question)]);
    return <Box pb={2} pt={2} >
        <Typography pb={1} style={{ whiteSpace: 'pre-line' }}>{props.sequencePrefix}{props.question.sequence}. {props.question.questionText} {props.question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
        <Box pl={2}>
            {/* readOnly is merged into inputProps to prevent editing when the form is read-only */}
            <TextField inputRef={inputRef} variant="outlined" inputProps={{ maxLength: 12, readOnly: props.readOnly }} style={{ border: "1px solid #115C71", borderRadius: 5, width: "80%" }} isRequired={props.question.isRequired} value={answer} onChange={(event) => {
                // Do not update state when the field is in read-only mode
                if (props.readOnly) return;
                const regex = /^[0-9\b]+$/;
                if (event.target.value === "" || regex.test(event.target.value)) {
                    setAnswer(event.target.value);
                    props.onChange(event.target.value);
                }

            }} />
            {props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "") ? <Alert severity="error" style={{ background: "transparent" }}>Required</Alert> : null}
        </Box>
    </Box>;
}

/**
 * Renders a multiple-choice question as either checkboxes (multi-select) or radio buttons (single-select).
 * The display variant is determined by question.isMultipleChoice.
 * @param {Object}   props.question        - Question data including options array (each with id, display, selected)
 * @param {boolean}  props.readOnly        - When true, all inputs are disabled and cannot be changed
 * @param {boolean}  props.validate        - When true, shows a validation error when no option is selected for a required question
 * @param {string}   props.sequencePrefix  - Optional prefix string prepended to the question sequence number
 * @param {Function} props.onChange        - Callback invoked with an array of selected option IDs on change
 */
function MultipleChoiceQuestionDisplay(props) {
    const [question, setQuestion] = useState(props.question);
    const inputRef = useRef(null);
    useEffect(() => {
        setQuestion(props.question);
        if (inputRef.current != null && props.validate && props.question.isRequired && (props.question.answerText === null || props.question.answerText === "")) {
            inputRef.current.focus();
            //inputRef.current.scrollIntoView();
        }
    }, [JSON.stringify(props.question)]);

    const showValidateMessage = () => {
        if (props.validate && question.isRequired &&
            question.options.filter(t => t.selected).length === 0)
            return <Alert severity="error" style={{ background: "transparent" }}>Required</Alert>;
        else
            return null;
    }

    if (question.isMultipleChoice) {
        return <Box pb={2} pt={2} >
            <Typography pb={1} style={{ whiteSpace: 'pre-line' }}>{props.sequencePrefix}{question.sequence}. {question.questionText} {question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
            <Box pl={2} >
                <FormGroup row={question.optionsDisplayOrientation === 1} sx={question.optionsDisplayOrientation === 1 ? { flexWrap: 'wrap' } : undefined}>
                    {question.options !== null && question.options.map((option, oIndex) => {
                        {/* disabled prevents editing when the form is in read-only mode */}
                        return <FormControlLabel key={oIndex} control={<Checkbox inputRef={inputRef} value={option.id} disabled={props.readOnly} defaultChecked={option.selected === true} onChange={(event) => {
                            // Do not update state when the control is read-only (also enforced by disabled prop)
                            if (props.readOnly) return;
                            question.options.map(item => {
                                if (item.id === event.target.value)
                                    item.selected = event.target.checked;
                            })
                            setQuestion(question);
                            let temp = [];
                            question.options.map(item => {
                                if (item.selected) {
                                    temp.push(item.id);
                                }
                            })
                            props.onChange(temp);
                        }} />} label={option.display} />;
                    })}
                </FormGroup>
                {showValidateMessage()}
            </Box>
        </Box>;
    } else {
        return <Box pb={2} pt={2}>
            <Typography pb={1} style={{ whiteSpace: 'pre-line' }}>{props.sequencePrefix}{question.sequence}. {question.questionText} {question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
            <Box pl={2}>
                <RadioGroup inputRef={inputRef}
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue={question.options.filter(t => t.selected).length > 0 ? question.options.filter(t => t.selected)[0].id : ""}
                    name="radio-buttons-group"
                    row={question.answerType === 6 || question.answerType === 7 || question.optionsDisplayOrientation === 1}
                    isRequired={question.isRequired}
                >
                    {question.options !== null && question.options.map((option, oIndex) => {
                        {/* disabled prevents editing when the form is in read-only mode */}
                        return <FormControlLabel key={oIndex} value={option.id} control={<Radio value={option.id} disabled={props.readOnly} onChange={(event) => {
                            // Do not update state when the control is read-only (also enforced by disabled prop)
                            if (props.readOnly) return;
                            let temp = [];
                            for (let k in question.options) {
                                if (question.options[k].id === option.id) {
                                    question.options[k].selected = true;
                                    temp.push(option.id);
                                } else {
                                    question.options[k].selected = false;
                                }
                            }
                            props.onChange(temp);
                        }} />} label={option.display} />;
                    })}
                </RadioGroup>
                {showValidateMessage()}
            </Box>
        </Box>;
    }
}

/**
 * Renders a grid question (AnswerType 8) as a table.
 * GridColumns define column headers and the input type per cell.
 * GridRows define row labels (sub-questions) and hold cell answers.
 * Column InputType: 1=SingleChoice (radio, one per row), 2=MultipleChoice (checkbox),
 *                   3=Text, 4=Number, 5=Date
 */
function GridQuestionDisplay({ question, readOnly, validate, sequencePrefix, onChange }) {
    const columns = (question.gridColumns || []).slice().sort((a, b) => a.order - b.order);
    const [rows, setRows] = useState(
        (question.gridRows || []).slice().sort((a, b) => a.order - b.order)
    );

    useEffect(() => {
        setRows((question.gridRows || []).slice().sort((a, b) => a.order - b.order));
    }, [JSON.stringify(question.gridRows)]);

    const updateSupportAnswerText = (rowId, value) => {
        const newRows = rows.map(row =>
            row.id === rowId ? { ...row, supportAnswerText: value } : row
        );
        setRows(newRows);
        question.gridRows = newRows;
        onChange(newRows);
    };

    const getCell = (row, columnId) =>
        (row.cells || []).find(c => c.columnId === columnId) || { columnId, isSelected: false, answerText: '' };

    const updateCell = (rowId, columnId, updates) => {
        const col = columns.find(c => c.id === columnId);
        const isSingleChoice = col && col.inputType === 1;

        const newRows = rows.map(row => {
            if (row.id !== rowId) return row;
            const cellMap = {};
            (row.cells || []).forEach(cell => { cellMap[cell.columnId] = { ...cell }; });
            columns.forEach(c => {
                if (!cellMap[c.id]) cellMap[c.id] = { columnId: c.id, isSelected: false, answerText: '' };
            });
            if (isSingleChoice) {
                // Radio: deselect all SingleChoice columns in the row, select only the clicked one
                columns.forEach(c => {
                    if (c.inputType === 1) cellMap[c.id] = { ...cellMap[c.id], isSelected: c.id === columnId };
                });
            } else {
                cellMap[columnId] = { ...cellMap[columnId], ...updates };
            }
            return { ...row, cells: Object.values(cellMap) };
        });

        setRows(newRows);
        question.gridRows = newRows;
        onChange(newRows);
    };

    const isAnswered = rows.some(row =>
        (row.cells || []).some(cell => cell.isSelected || (cell.answerText && cell.answerText !== ''))
    );

    const cellStyle = { border: '1px solid #ccc', padding: '8px', textAlign: 'center' };
    const headerStyle = { border: '1px solid #ccc', padding: '8px', textAlign: 'center', background: '#f5f5f5', fontWeight: 'bold' };

    return <Box pb={2} pt={2}>
        <Typography pb={1} style={{ whiteSpace: 'pre-line' }}>{sequencePrefix}{question.sequence}. {question.questionText} {question.isRequired ? <span style={{ color: "#e57373" }}>*</span> : null}</Typography>
        <Box pl={2} sx={{ overflowX: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                    <tr>
                        <th style={{ ...headerStyle, textAlign: 'left', minWidth: '150px' }}></th>
                        {columns.map(col => (
                            <th key={col.id} style={headerStyle}>{col.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map(row => (
                        <tr key={row.id}>
                            <td style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>
                                <span style={{ whiteSpace: 'pre-line' }}>{row.label}</span>
                                <Box mb={2}></Box>
                                {row.allowSupportAnswerText && (
                                    <TextField
                                        multiline
                                        minRows={2}
                                        fullWidth
                                        disabled={readOnly}
                                        value={row.supportAnswerText || ''}
                                        inputProps={{ maxLength: 500 }}
                                        variant="outlined"
                                        size="small"
                                        placeholder="Support answer here..."
                                        style={{ marginTop: '6px' }}
                                        onChange={(e) => { if (!readOnly) updateSupportAnswerText(row.id, e.target.value); }}
                                    />
                                )}
                            </td>
                            {columns.map(col => {
                                const cell = getCell(row, col.id);
                                return <td key={col.id} style={cellStyle}>
                                    {col.inputType === 1 && (
                                        <Radio
                                            disabled={readOnly}
                                            checked={cell.isSelected}
                                            onChange={() => { if (!readOnly) updateCell(row.id, col.id, { isSelected: true }); }}
                                            size="small"
                                        />
                                    )}
                                    {col.inputType === 2 && (
                                        <Checkbox
                                            disabled={readOnly}
                                            checked={cell.isSelected}
                                            onChange={(e) => { if (!readOnly) updateCell(row.id, col.id, { isSelected: e.target.checked }); }}
                                            size="small"
                                        />
                                    )}
                                    {col.inputType === 3 && (
                                        <>
                                        <TextField
                                            disabled={readOnly}
                                            value={cell.answerText}
                                            variant="outlined"
                                            size="small" inputProps={{ maxLength: 300 }} multiline={true}
                                            onChange={(e) => { if (!readOnly) updateCell(row.id, col.id, { answerText: e.target.value }); }}
                                        />
                                        <Typography variant="caption" style={{ display: "block", textAlign: "right", width: "100%", color: (cell.answerText?.length ?? 0) >= 300 ? "#e57373" : "#888" }}>
                                            {cell.answerText?.length ?? 0} / 300
                                        </Typography></>
                                    )}
                                    {col.inputType === 4 && (
                                        <TextField
                                            disabled={readOnly}
                                            value={cell.answerText}
                                            variant="outlined"
                                            size="small"
                                            inputProps={{ inputMode: 'numeric' }}
                                            onChange={(e) => {
                                                if (readOnly) return;
                                                const regex = /^[0-9\b]+$/;
                                                if (e.target.value === '' || regex.test(e.target.value))
                                                    updateCell(row.id, col.id, { answerText: e.target.value });
                                            }}
                                        />
                                    )}
                                    {col.inputType === 5 && (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                format="DD/MM/YYYY"
                                                readOnly={readOnly}
                                                value={cell.answerText && dayjs(cell.answerText).isValid() ? dayjs(cell.answerText) : null}
                                                onChange={(newValue) => {
                                                    if (!readOnly)
                                                        updateCell(row.id, col.id, { answerText: newValue && newValue.isValid() ? newValue.format('YYYY-MM-DD') : '' });
                                                }}
                                                slotProps={{ textField: { variant: 'outlined', size: 'small' } }}
                                            />
                                        </LocalizationProvider>
                                    )}
                                </td>;
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
            {validate && question.isRequired && !isAnswered
                ? <Alert severity="error" style={{ background: 'transparent' }}>Required</Alert>
                : null}
        </Box>
    </Box>;
}
